export const multiDayAllDayFormatString = "Ara";
export default {multiDayAllDayFormatString};